import styled from 'styled-components';

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #1d3557;
  
  &:hover {
    color: #e63946;
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 20px;
`;

const ProductName = styled.h2`
  color: #1d3557;
  margin-bottom: 15px;
  font-size: 1.8rem;
`;

const ProductPrice = styled.p`
  color: #e63946;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Description = styled.p`
  color: #333;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const AddToCartButton = styled.button`
  background-color: #25D366;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #128C7E;
  }
`;

const ProductDetails = ({ product, onClose }) => {
  if (!product) return null;

  const handleAddToCart = () => {
    const message = `Bonjour New Malamba Business, je vous contact pour commander :\n${product.image}\nProduit : ${product.name}\nPrix : ${product.price}`;
    const whatsappUrl = `https://wa.me/243994999555?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Modal onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <ProductImage src={product.image} alt={product.name} />
        <ProductName>{product.name}</ProductName>
        <ProductPrice>{product.price}</ProductPrice>
        <Description>
          {product.description || `Description détaillée du produit ${product.name}. Nous fournissons des produits de haute qualité pour répondre à tous vos besoins professionnels.`}
        </Description>
        <AddToCartButton onClick={handleAddToCart}>Commander via WhatsApp</AddToCartButton>
      </ModalContent>
    </Modal>
  );
};

export default ProductDetails;